import React from 'react';

const AddSetButton = ({ type, onClick, disabled }) => {
  const isInclude = type === 'include';
  const text = isInclude ? 'Add New Inclusion Set' : 'Add New Exclusion Set';
  const icon = isInclude ? 'add_circle_outline' : 'remove_circle_outline';

  return (
    <button
      type="button"
      className={`aud-v2-add-set aud-v2-add-set--${type}`}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="material-icons">{icon}</span>
      <span>{text}</span>
    </button>
  );
};

export default AddSetButton;
